module.exports = __webpack_public_path__ + "img/small_flug_deactive.db6e2920.svg";